<script>

import {vueAppMixin} from "@/mixins/vueAppMixin";
export default {
  name: "CrewList",
  mixins: [vueAppMixin],
}
</script>

<template>
  <div>
    <div class="row mb-2">
      <div class="col-12">
        <nav class="bg-light">
          <ul class="nav nav-tabs nav-fill w-100" id="nav-tab" role="tablist">
            <li class="nav-item">
              <router-link
                :to="{name: 'VesselOnboardCrewLists' }"
                tag="a"
                class="nav-link border border-bottom-0"
                :class="{'active text-white': isActiveRoute('VesselOnboardCrewLists')}"
                role="tab"
                data-toggle="list"
              >
                Onboard Crews
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{name: 'VesselEmbarkDisembarkHistory'}"
                tag="a"
                class="nav-link border border-bottom-0"
                :class="{'active text-white': isActiveRoute('VesselEmbarkDisembarkHistory')}"
                role="tab"
                data-toggle="list"
              >
                Embarkation/Disembarkation History
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<style scoped>
.active{
  background-color: #dc3545 !important;
}
</style>
